/**
 * 补全图片路径
 * @param {图片地址} file 
 */
import { baseImgUrl } from "../request/index"
function setImgUrl(url) {
	if(url){
    if(url.indexOf('http') == -1){
      url = baseImgUrl + url
    }
  }
	return url;
}

export {
  setImgUrl
}